import { render, staticRenderFns } from "./GradeSubmission.vue?vue&type=template&id=ec0dc58c&scoped=true&"
import script from "./GradeSubmission.vue?vue&type=script&lang=js&"
export * from "./GradeSubmission.vue?vue&type=script&lang=js&"
import style0 from "./GradeSubmission.vue?vue&type=style&index=0&id=ec0dc58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0dc58c",
  null
  
)

export default component.exports